import * as yup from "yup";

const validationSchema = yup.object().shape({
  source_variable: yup
    .object()
    .shape({
      label: yup.string().required(),
      value: yup.string().required(),
    })
    .required("Source variable is required.")
    .nullable(),

  rule: yup
    .object()
    .shape({
      label: yup.string().required(),
      value: yup.string().required(),
    })
    .required("Rule is required.")
    .nullable(),

  source_value: yup.string().required("Source value is required."),

  target_variable: yup
    .object()
    .shape({
      label: yup.string().required(),
      value: yup.string().required(),
    })
    .required("Target variable is required.")
    .nullable(),

  target_value: yup.string().required("Target_value is required"),
});

export default validationSchema;
